/**
 * 监听 window scroll
 * @param callback
 * @param depend 依赖
 */
import { useEffect, useRef } from 'react';
import { $window, docElement } from '@umu/umu-dom';
import { throttle } from '@umu/umu-util';

let scrollTop = docElement.scrollTop;
let startTop = docElement.scrollTop;

/**
 * 监听滚动
 * @param callback 回调
 * @param depend 依赖
 * @param action 启动或取消监听
 * @author Kody
 */
export const useListenScroll = (callback: (distance: number) => void, depend: any[] = [], action = true) => {
    const callbackRef = useRef(callback);
    callbackRef.current = callback;
    let timer: number = 0;

    const scroll = throttle(() => {
        if (timer) {
            $window.clearTimeout(timer);
        }
        scrollTop = docElement.scrollTop;
        timer = $window.setTimeout(() => {
            const newScroppTop = docElement.scrollTop;
            if (scrollTop === newScroppTop) {
                startTop = scrollTop;
            }
        }, 300);
        callbackRef.current(docElement.scrollTop - startTop);
    }, 100);
    useEffect(() => {
        if (action) {
            $window.addEventListener('scroll', scroll);
        }
        return () => {
            $window.removeEventListener('scroll', scroll);
        };
    }, [action, ...depend]);
};
